import { CountryList } from "client/lib/apt-merchant";

export interface GTM {
  event: GTMEvent;
  existingEmail?: "Yes" | "No";
  formSubmission?: "Successful" | "Unsuccessful";
  storeFormComplete?: boolean;
  bankFormComplete?: boolean;
  country?: CountryList;
  category?: string;
  businessType?: string;
  salesChannel?: string;
  totalAnnualSales?: string;
  platform?: string;
}

export type GTMEvent =
  | "OptInButtonClick"
  | "FormButtonClick"
  | "DashboardPageView"
  | "QualificationPageView"
  | "SignInPageView"
  | "OptInPageView"
  | "FormPageView"
  | "BizDetailsUpload"
  | "PayInfoUpload";

export const addToGTMDataLayer = (gtmObj: GTM): void => {
  window.dataLayer?.push(gtmObj);
};
